import React, { useState, useEffect } from "react";
import { Box, Typography } from "fds";
import "./index.scss";
import { DocInfo, DocumentListReq, DocumentListResp } from "../../types/files";
import DocumentBottom from "../../components/DocumentBottom";
import useDocumentStore from "../../redux/dispatcher/useDocumentStore";
import { t } from "i18next";
const Trash = () => {
  /** Hook모음 */
  const { documentState, getContentList } = useDocumentStore();

  /** State모음 */
  const [docInfo, changeDocListInfo] = useState<DocumentListResp>();
  const [filter, changeFilters] = useState<DocumentListReq>({
    page: 0,
    size: 50,
    order: "datedesc",
    search: "",
    readType: "trash",
    masterUserId: "",
    tagCodes: [],
    date: {
      start: 0,
      end: 0,
    },
    folderCode: "",
  });

  /** 함수 모음*/
  useEffect(() => {
    getContentList(filter);
  }, [filter]);
  useEffect(() => {
    changeDocListInfo(documentState.docListInfo);
  }, [documentState.docListInfo]);

  /** 함수 모음 */
  /** 필터 변경 함수 */
  const changeFilterByKey = (key: string, value: any) => {
    let newValue = value;
    if (key === "order") {
      if (value.includes("_direct")) {
        newValue = value.split("_direct")[0];
      } else {
        if (value === "file") {
          if (filter.order.includes("date")) {
            newValue = "filedesc";
          } else {
            newValue = filter.order === "filedesc" ? "file" : "filedesc";
          }
        } else {
          if (filter.order.includes("name")) {
            newValue = "datedesc";
          } else {
            newValue = filter.order === "datedesc" ? "date" : "datedesc";
          }
        }
      }
    } else if (key === "page") {
      if (
        docInfo &&
        docInfo?.docs?.doc &&
        docInfo?.docs?.doc.length < docInfo?.total
      ) {
        changeFilters({ ...filter, [key]: newValue });
      }
      return;
    }
    changeFilters({ ...filter, [key]: newValue.replace("name", "file") });
  };

  return (
    <Box width={"100%"} height={"100%"} classes={"trash body"}>
      <Box height={96} classes={"layout-title"}>
        <Typography type="h1">{t("trash.title")}</Typography>
      </Box>
      <DocumentBottom
        filter={filter}
        changeFilterByKey={changeFilterByKey}
        height={"calc(100% - 145px)"}
        listTableHeight={"calc(100vh - 304px)"}
        docInfo={docInfo}
        isInitFilter
        page={"trash"}
        endReached={() => changeFilterByKey("page", filter.page + 1)}
      />
    </Box>
  );
};

export default Trash;
